import {
  isServerResponseError,
  hasError,
} from '../common'
import {
  pathOr,
  prop,
} from 'ramda'
import {
  getTaxonomyWaterUsage
} from '../../services/apis'

const getTaxonomyUsageData = async (id, from, to) => {
  const result = await getTaxonomyWaterUsage(id)({
    from,
    to
  })
  return isServerResponseError(result) || hasError(result)
    ? []
    : pathOr([], ['data', 'data'], result)
}

export default getTaxonomyUsageData
